import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./reducers"; // Adjust the import if needed
import { persistStore } from "redux-persist";

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: false,
    });
  },
  devTools: {
    name: `Multisteps_Store_${process.env.NODE_ENV}`,
  },
});

const persistor = persistStore(store);

export { store, persistor };
export default store;
